import { Button, Text } from "@fmc-digital/ui";

/**
 * Shown when app initialization fails (e.g. getAppInitPromise resolves with null or rejects).
 */
export function InitErrorPage({
  error,
  onRetry,
}: Readonly<{
  error: Error;
  onRetry?: () => void;
}>) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface">
      <div className="text-center max-w-md px-4">
        <Text variant="bodyLarge" className="text-error">
          Initialization failed
        </Text>
        <Text variant="bodyMedium" className="mt-2 text-on-surface-variant">
          {error.message}
        </Text>
        {onRetry && (
          <Button className="mt-4" variant="filled" onClick={onRetry}>
            Retry
          </Button>
        )}
      </div>
    </div>
  );
}
